import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DocumentService } from 'src/app/services/document.service';
import { HttpRequestsService } from 'src/app/services/http-requests.service';

@Component({
  selector: 'app-moderator',
  templateUrl: './moderator.component.html',
  styleUrls: ['./moderator.component.scss'],
})
export class ModeratorComponent implements OnInit {
  public viewDocument: any;
  public documents = [];

  constructor(private req: HttpRequestsService<any>,private router: Router, private doc:DocumentService) {}

  ngOnInit() {
    this.req.getUnpublishedDocs().subscribe((res) => this.documents = res);
    console.log(this.documents)
  }

  goToView(id) {
    this.req.getDocument(id).subscribe(
      (res) => {
        this.viewDocument = res[0];
      },
      (error) => console.log(error),
      () =>{
        (this.doc.data = this.viewDocument)
        this.router.navigate(['ModeratorView']);
      } 
    );
  }
}
